import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {PlanningViewSettingsJobsModel} from "../../models/planning-view-settings.model";
import {PlanningPanelModel} from "../../models/planning-panel.model";
import {LeftoverConstrainModel} from "../../models/leftover-constrain.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {JobsGroupByEnum} from "../../types/jobs-group-by.enum";
import {PanelService} from "../../../commons/angular/services/panel.service";
import {
  PlanningDraftJobsSortingDialogComponent
} from "../../angular/components/planning-draft-jobs-sorting-dialog/planning-draft-jobs-sorting-dialog.component";
import {
  PlanningJobsHelperService,
  PlanningJobsFilterContext,
  PlanningJobsSortContext
} from "../../services/planning-jobs-helper.service";
import {PlanningViewMode} from "../../types/planning-view-mode.enum";

export class PlanningDraftJobsPanelComponent implements IController {

  draft?: any;
  jobs: any[];
  routes: any[];
  resources: any[];
  panel: PlanningPanelModel;
  panels: PlanningPanelModel[];
  selectedJobs: any[];
  selectedIds: string[];
  settings: PlanningViewSettingsJobsModel;
  highlightedActivity: any;
  isDisplayLayoutWrap: boolean;
  itemElementSize: string;
  jobsGroupByType: JobsGroupByEnum;
  highlightedRouteIds: Set<string>;
  highlightedLeftoverIds: Set<string>;
  selectedClusterId: string;
  onSettingsChange: Function;
  onViewJob: Function;
  onViewGroupedJob: Function;
  onSelectJobs: Function;
  onCreateRouteByJobs: Function;
  onUpdateRouteByJobs: Function;
  onAddJobsToDraft: Function;
  onRemoveJobs: Function;
  onMoveToLeftovers: Function;
  onPanelChange: Function;
  onChangeJobsGroupByType: Function;
  onToggleObligateTimeWindow: Function;
  onToggleLockJobs: Function;
  onContextMenu: Function;
  onReverseJobSplit: Function;
  onResetCluster: Function;
  onOpenRouteInFloatingTable: Function;
  viewMode: PlanningViewMode;

  public filteredJobs: any[]
  public filteredGroupedJobs: any[];
  public leftoverConstrains: LeftoverConstrainModel[];
  public includeFilters: SiteFiltersType[];
  public dropdownFilters: any;
  public filtersQueryMap: any;
  public pageName: string = 'planning-services';
  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;
  public jobsGroupByEnum: typeof JobsGroupByEnum = JobsGroupByEnum;
  public planningViewMode: typeof PlanningViewMode = PlanningViewMode;
  public groupedJobs: any[];
  public sortBy: string;
  public sortByType: any;
  public expandedGroupedJobs: { [key: string]: boolean } = {};
  public hasOneExpandedGroup: boolean = false;

  /* @ngInject */
  constructor(private $timeout: ITimeoutService, private UUIDService, private panelService: PanelService, private $filter, private planningJobsHelperService: PlanningJobsHelperService) {
  }

  $onInit() {
    if (!this.draft) {
      this.panel = {};
    }

    this.planningJobsHelperService.initFilters(this.panel);
    this._setIncludeFilters();
    this._setDropdownFilters();
    this.sortBy = this.panel.tabsFilterConfig[this.panel.selectedTabIndex].sortBy;
    this.sortByType = this.panel.tabsFilterConfig[this.panel.selectedTabIndex].sortByType || 'desc';

    this._setLeftoverConstraints();
    this._setFiltersQueryMap();
    this._setGroupJobsByType();
    this._setFilteredJobs();
  }

  $onChanges(changes: angular.IOnChangesObject) {

    if ((changes.panel && !changes.panel.isFirstChange()) ||
      (changes.selectedIds && !changes.selectedIds.isFirstChange())) {

      const currentSelectedIds = _.get(changes.selectedIds, 'currentValue', []),
        previousSelectedIds = _.get(changes.selectedIds, 'previousValue', []),
        removedSelectedIds = _.difference(previousSelectedIds, currentSelectedIds),
        addedSelectedIds = _.difference(currentSelectedIds, previousSelectedIds);

      if ((removedSelectedIds?.length || addedSelectedIds.length) && this.settings?.general?.autoMoveSelectionToTop) {
        this._sortJobs(this.filteredJobs, this.filteredGroupedJobs);
      }

      const currentPanel = changes.panel?.currentValue,
        previousPanel = changes.panel?.previousValue;

      if (changes.panel) {
        this._setDropdownFilters();
      }

      if ((currentPanel?.tabsFilterConfig[this.panel.selectedTabIndex]?.sortBy !== previousPanel?.tabsFilterConfig[this.panel.selectedTabIndex]?.sortBy) ||
        (currentPanel?.tabsFilterConfig[this.panel.selectedTabIndex]?.sortByType !== previousPanel?.tabsFilterConfig[this.panel.selectedTabIndex]?.sortByType)) {
        this.sortBy = this.panel.tabsFilterConfig[this.panel.selectedTabIndex].sortBy;
        this.sortByType = this.panel.tabsFilterConfig[this.panel.selectedTabIndex].sortByType;

        this._sortJobs(this.filteredJobs, this.filteredGroupedJobs);
      }
    }

    if (changes.jobs && !changes.jobs.isFirstChange()) {
      this._setGroupJobsByType();
      this._setFilteredJobs();
    }
    if (changes.draft && !changes.draft.isFirstChange()) {
      this._setLeftoverConstraints();
      this._setFiltersQueryMap();
    }

    if (changes.routes && !changes.routes.isFirstChange()) {
      this._setFiltersQueryMap();
    }

    if (changes.jobsGroupByType && !changes.jobsGroupByType.isFirstChange()) {
      this._setGroupJobsByType();
      this._setFilteredJobs();
    }

    if (changes.settings && !changes.settings.isFirstChange()) {
      this._sortJobs(this.filteredJobs, this.filteredGroupedJobs);
    }

    if (changes.selectedClusterId && !changes.selectedClusterId.isFirstChange()) {
      this._setIncludeFilters();
      this._setDropdownFilters();
    }

    if ((changes.selectedClusterId && changes.selectedClusterId.isFirstChange()) || (changes.highlightedRouteIds && !changes.highlightedRouteIds.isFirstChange())) {
      this._setFilteredJobs();
    }
  }

  onQueryChanged(query) {
    this.panel.tabsFilterConfig[this.panel.selectedTabIndex].queryString = query;

    this._setFilteredJobs();
    this.onPanelChange({panel: this.panel});
  }

  onJobsFiltersChange(filters) {
    const filterConfig = this.panel.tabsFilterConfig[this.panel.selectedTabIndex];
    // The dropdown emits null for "All" on boolean filters; the jobs filter treats only undefined as "no filter"
    const updatedFilters = _.mapValues(_.pick(filters, this.includeFilters), (value) => _.isNull(value) ? undefined : value);
    Object.assign(filterConfig, _.omit(updatedFilters, [this.siteFiltersType.serviceSkills, this.siteFiltersType.cluster]), {
      [this.siteFiltersType.agentSkills]: updatedFilters[this.siteFiltersType.serviceSkills],
      [this.siteFiltersType.leftoverConstrains]: _.map(updatedFilters[this.siteFiltersType.leftoverConstrains], (name) => ({name}))
    });

    if (this.selectedClusterId && !updatedFilters[this.siteFiltersType.cluster]) {
      filterConfig[this.siteFiltersType.cluster] = '';
      this.onResetCluster();
    }

    this._setDropdownFilters();
    this._setFilteredJobs();
    this.onPanelChange({panel: this.panel});
  }

  onToggleAllJobs() {
    const selectedIds: any[] = !this.selectedIds.length ?
      _.chain(this.filteredJobs)
        .filter((j) => {
          return !j.locked
        })
        .map((filteredJob) => {
          return filteredJob.id;
        })
        .value() : [];

    this.onSelectJobs({ids: selectedIds});
  }

  onToggleSort() {
    const panel = this.panelService.open(PlanningDraftJobsSortingDialogComponent, event, {
      sortBy: this.sortBy,
      sortByType: this.sortByType,
    }, {
      position: {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'top',
      },
      width: 160,
      height: 288
    })

    if (panel) {
      panel.instance.onSortTypeChange.subscribe(data => {

        if (!!this.draft) {
          const panelCopy = angular.copy(this.panel);
          panelCopy.tabsFilterConfig[this.panel.selectedTabIndex].sortBy = data.sortBy;
          panelCopy.tabsFilterConfig[this.panel.selectedTabIndex].sortByType = data.sortByType;
          this.onPanelChange({panel: panelCopy});
        } else {
          this.sortBy = data.sortBy;
          this.sortByType = data.sortByType;

          this._sortJobs(this.filteredJobs, this.filteredGroupedJobs);
          this.$timeout(() => {}, 0);
        }
      });
    }
  }

  onToggleExpandAllGroupedJobs() {
    if (Object.keys(this.expandedGroupedJobs).length) {
      this.expandedGroupedJobs = {};
    } else {
      this.filteredGroupedJobs?.forEach((job) => {
        if (job.groupedByType) {
          this.expandedGroupedJobs[job.id] = true;
        }
      });
    }

    this.hasOneExpandedGroup = Object.keys(this.expandedGroupedJobs).length > 0;
    this.expandedGroupedJobs = { ...this.expandedGroupedJobs };
  }

  onGroupExpanded(id: string, expanded: boolean) {
    if (expanded) {
      this.expandedGroupedJobs[id] = true;
    } else {
      delete this.expandedGroupedJobs[id];
    }

    this.hasOneExpandedGroup = Object.keys(this.expandedGroupedJobs).length > 0;
    this.expandedGroupedJobs = { ...this.expandedGroupedJobs };
  }

  private _setIncludeFilters() {
    this.includeFilters = [
      SiteFiltersType.branchIds,
      SiteFiltersType.depotIds,
      SiteFiltersType.serviceSkills,
      SiteFiltersType.serviceAreaIds,
      SiteFiltersType.tags,
      SiteFiltersType.labels,
      SiteFiltersType.isPacked,
      SiteFiltersType.isSynced,
      ...(this.draft ? [SiteFiltersType.inRoute, SiteFiltersType.resourceIds, SiteFiltersType.leftoverConstrains] : []),
      ...(this.selectedClusterId ? [SiteFiltersType.cluster] : [])
    ];
  }

  private _setDropdownFilters() {
    const filterConfig = this.panel.tabsFilterConfig[this.panel.selectedTabIndex];
    this.dropdownFilters = {
      ..._.pick(filterConfig, this.includeFilters),
      [this.siteFiltersType.serviceSkills]: filterConfig[this.siteFiltersType.agentSkills],
      [this.siteFiltersType.leftoverConstrains]: _.map(filterConfig[this.siteFiltersType.leftoverConstrains], 'name'),
      [this.siteFiltersType.cluster]: this.selectedClusterId || undefined
    };
  }

  private _setFiltersQueryMap() {
    this.filtersQueryMap = {
      resourceOptions: _.chain(this.routes)
        .filter((r) => r.resource)
        .map('resource')
        .uniqBy('id')
        .map((resource) => ({id: resource.id, name: resource.allocationName || resource.vehicleName}))
        .value(),
      leftoverConstrainOptions: _.map(this.leftoverConstrains, (constrain) => ({
        id: constrain.name,
        name: 'PLANNING_DRAFT_LEFTOVERS_REASONS.' + constrain.name + '.name'
      }))
    };
  }

  private _setLeftoverConstraints() {
    this.leftoverConstrains = this.planningJobsHelperService.setLeftoverConstraints(this.draft);
  }

  private _setGroupJobsByType() {
    this.groupedJobs = this.planningJobsHelperService.setGroupJobsByType(this.jobs, this.jobsGroupByType, this.routes);
  }

  private _setFilteredJobs() {
    this.planningJobsHelperService.setJobsData(this.jobs, this.routes);
    this.planningJobsHelperService.setJobsData(this.groupedJobs, this.routes);

    const filterContext: PlanningJobsFilterContext = {
      filterConfig: this.panel.tabsFilterConfig[this.panel.selectedTabIndex],
      jobIdToUnassignedJobData: this.draft?.jobIdToUnassignedJobData,
      selectedClusterId: this.selectedClusterId,
      highlightedRouteIds: this.highlightedRouteIds,
      highlightedLeftoverIds: this.highlightedLeftoverIds
    };

    this.$timeout(0).then(() => {
      const filteredJobs = this.jobs ? _.filter(this.jobs, (j) => {
        return this.planningJobsHelperService.filterJobByFilters(j, filterContext);
      }) : undefined;

      const filteredGroupedJobs = this.jobs ? _.filter(this.groupedJobs, (j) => {
        return this.planningJobsHelperService.filterGroupJobByFilters(j, filterContext);
      }) : undefined;

      this._sortJobs(filteredJobs, filteredGroupedJobs);
    });
  }

  private _sortJobs(jobs, groupedJobs) {
    const sortContext: PlanningJobsSortContext = {
      sortBy: this.sortBy,
      sortByType: this.sortByType,
      autoMoveSelectionToTop: !!this.settings?.general?.autoMoveSelectionToTop,
      selectedIds: this.selectedIds,
      routes: this.routes
    };

    this.filteredJobs = this.planningJobsHelperService.getSortedJobs(jobs, sortContext);
    this.filteredGroupedJobs = this.planningJobsHelperService.getSortedJobs(groupedJobs, sortContext);
    this.expandedGroupedJobs = {};
    window.dispatchEvent(new Event('resize'));
  }
}

angular.module('bringoz.admin.planning')
  .component(
    'planningDraftJobsPanel'
    , {
      bindings: {
        draft: '<?',
        jobs: '<',
        routes: '<',
        resources: '<',
        panel: '<',
        panels: '<',
        selectedJobs: '<',
        selectedIds: '<',
        settings: '<',
        highlightedActivity: '<?',
        itemElementSize: '<',
        jobsGroupByType: '<?',
        highlightedRouteIds: '<?',
        highlightedLeftoverIds: '<?',
        selectedClusterId: '<?',
        viewMode: '<',
        onSettingsChange: '&',
        onViewJob: '&',
        onViewGroupedJob: '&',
        onSelectJobs: '&',
        onCreateRouteByJobs: '&',
        onUpdateRouteByJobs: '&',
        onAddJobsToDraft: '&',
        onRemoveJobs: '&',
        onMoveToLeftovers: '&',
        onPanelChange: '&',
        onChangeJobsGroupByType: '&',
        onToggleObligateTimeWindow: '&',
        onToggleLockJobs: '&',
        onContextMenu: '&',
        onReverseJobSplit: '&',
        onResetCluster: '&',
        onOpenRouteInFloatingTable: '&'
      }, template: require('./planning-draft-jobs-panel.html').default,
      controller: PlanningDraftJobsPanelComponent
    }
  )
;
